import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getOptimizedImage } from '../../utils/cloudinary';
import HomeCategories from "./HomeCategories";
import HomeProductTrending from "./HomeProductTrending";
import HomeBrands from "./HomeBrands";

export default function HomePage() {
  const { t } = useTranslation();

  const heroImage = getOptimizedImage(
  'https://res.cloudinary.com/dc6xthiol/image/upload/v1774514356/mb_zegl9q.png',
  { width: 600, quality: 'auto', format: 'auto' }
);
const heroImageDesktop = getOptimizedImage(
  'https://res.cloudinary.com/dc6xthiol/image/upload/v1774514356/mb_zegl9q.png',
  { width: 1400, quality: 'auto', format: 'auto' }
);

  const offers = [
    {
      nameKey: "home.offers.downloadApp.name",
      descriptionKey: "home.offers.downloadApp.description",
      href: "#",
    },
    {
      nameKey: "home.offers.freeReturns.name",
      descriptionKey: "home.offers.freeReturns.description",
      href: "#",
    },
    {
      nameKey: "home.offers.newsletter.name",
      descriptionKey: "home.offers.newsletter.description",
      href: "#",
    },
  ];

  const perks = [
    {
      nameKey: "home.perks.visitUs.name",
      descriptionKey: "home.perks.visitUs.description",
      imageUrl:
        "https://res.cloudinary.com/dc6xthiol/image/upload/v1774662010/visitus1_avqlwk.png",
      linkUrl: "https://maps.app.goo.gl/tjVbGbJgrHEKtrkD8",
      linkTarget: "_blank"
    },
    {
      nameKey: "home.perks.sameDayDelivery.name",
      descriptionKey: "home.perks.sameDayDelivery.description",
      imageUrl:
        "https://res.cloudinary.com/dc6xthiol/image/upload/v1774592989/visitus_tjwznk.jpg",
      linkUrl: "https://maps.app.goo.gl/QQDiJQvZ2yauGXw59",
      linkTarget: "_blank"
    },
    {
      nameKey: "home.perks.forThePlanet.name",
      descriptionKey: "home.perks.forThePlanet.description",
      imageUrl:
        "https://res.cloudinary.com/dc6xthiol/image/upload/v1774655079/BEER-STYLES-740X740_byztsv.jpg",
      linkUrl: "/style-guide",
      linkTarget: "_self"
    },
    {
      nameKey: "home.perks.allYearDiscount.name",
      descriptionKey: "home.perks.allYearDiscount.description",
      imageUrl:
        "https://res.cloudinary.com/dc6xthiol/image/upload/v1774644479/cervezaArtesanalcursos_vlijvu.jpg",
      linkUrl: "/courses",
      linkTarget: "_self"
    },

  ];

  return (
    <div className="bg-white">
      <main>
        {/* Hero */}
        <div className="flex flex-col border-b border-gray-200 lg:border-0">


          <div className="relative">
            <div
              aria-hidden="true"
              className="absolute hidden h-full w-1/2 bg-gray-100 lg:block"
            />
            <div className="relative bg-black lg:bg-black">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:grid lg:grid-cols-2 lg:px-8">
                <div className="mx-auto max-w-2xl py-24 lg:max-w-none lg:py-64">
                  <div className="lg:pr-16">
                    <h1 className="text-4xl font-bold tracking-tight text-gray-300 sm:text-5xl xl:text-6xl">
                      {t("home.hero.title")}
                    </h1>
                    <p className="mt-4 text-xl text-gray-600">
                      {t("home.hero.description")}
                    </p>
                    {/*<div className="mt-6">
                      <a
                        href="#"
                        className="inline-block rounded-md border border-transparent bg-indigo-600 py-3 px-8 font-medium text-white hover:bg-indigo-700"
                      >
                        {t("home.hero.cta")}
                      </a>
                    </div>*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="h-48 w-full sm:h-64 lg:absolute lg:top-0 lg:right-0 lg:h-full lg:w-1/2">
              <img
                src={heroImageDesktop}
                srcSet={`${heroImage} 600w, ${heroImageDesktop} 1400w`}
                sizes="100vw"
                alt={t("home.hero.title")}
                className="h-full w-full object-cover object-center"
              />
            </div>
          </div>
        </div>

        <div className="relative overflow-hidden">
          {/* Sale */}
          <section
            aria-labelledby="sale-heading"
            className="relative mx-auto flex max-w-7xl flex-col items-center px-4 pt-32 text-center sm:px-6 lg:px-8"
          >
            <div className="mx-auto max-w-2xl lg:max-w-none">
              <h2
                id="sale-heading"
                className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl"
              >
                {t("home.sale.title")}
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-xl text-gray-600">
                {t("home.sale.description")}
              </p>
              <a
                href="#"
                className="mt-6 inline-block w-full rounded-md border border-transparent bg-gray-900 py-3 px-8 font-medium text-white hover:bg-gray-800 sm:w-auto"
              >
                {t("home.sale.cta")}
              </a>
            </div>
          </section>
        </div>
      </main>
      <main>
        {/* Category section */}
        <section
          aria-labelledby="category-heading"
          className="pt-24 sm:pt-32 xl:mx-auto xl:max-w-7xl xl:px-8"
        >
          <div className="px-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8 xl:px-0">
            <h2
              id="category-heading"
              className="text-2xl font-bold tracking-tight text-gray-900"
            >
              {t("home.categories.title")}
            </h2>
            {/*<Link
              to="/all-categories"
              className="hidden text-sm font-semibold text-indigo-600 hover:text-indigo-500 sm:block"
            >
              {t("home.categories.viewAll")}
              <span aria-hidden="true"> &rarr;</span>
            </Link>*/}
          </div> 

          {/* home categories */}
          <HomeCategories />
        </section>

        <section
          aria-labelledby="brands-heading"
          className="pt-24 sm:pt-32 xl:mx-auto xl:max-w-7xl xl:px-8"
        >
          <div className="px-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8 xl:px-0">
            <h2
              id="brands-heading"
              className="text-2xl font-bold tracking-tight text-gray-900"
            >
              {t("home.brands.title")}
            </h2>
            <Link
              to="/all-brands"
              className="hidden text-sm font-semibold text-indigo-600 hover:text-indigo-500 sm:block"
            >
              {t("home.brands.viewAll")}
              <span aria-hidden="true"> &rarr;</span>
            </Link>
          </div>

          {/* home brands */}
          <HomeBrands />
        </section>

        <section>
          {/* Home trending products */}
          <HomeProductTrending />
        </section>

        {/* info */}
        <section
          aria-labelledby="perks-heading"
          className="border-t border-gray-200 bg-gray-50"
        >
          <h2 id="perks-heading" className="sr-only">
            {t("home.perks.srOnly")}
          </h2>

          <div className="mx-auto max-w-7xl py-24 px-4 sm:px-6 sm:py-32 lg:px-8">
            <div className="grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-0">
              {perks.map((perk) => (
                <div
                  key={perk.nameKey}
                  className="text-center md:flex md:items-start md:text-left lg:block lg:text-center"
                >
                  <div className="md:flex-shrink-0">
                    <div className="flow-root">
                      <Link
                        to={perk.linkUrl || "#"}
                        className="block"
                        target={perk.linkTarget || "_self"}
                        rel={perk.linkTarget === "_blank" ? "noopener noreferrer" : ""}
                      >
                       <img
                            className="-my-1 mx-auto h-56 w-auto transition-transform duration-300 hover:scale-105 rounded-lg"
                            src={getOptimizedImage(perk.imageUrl, { height: 224, quality: 'auto', format: 'auto' })}
                            alt={t(perk.nameKey)}
                          />
                      </Link>
                    </div>
                  </div>
                  <div className="mt-6 md:mt-0 md:ml-4 lg:mt-6 lg:ml-0">
                    <h3 className="text-base font-medium text-gray-900">
                      <Link
                        to={perk.linkUrl || "#"}
                        target={perk.linkTarget || "_self"}
                        rel={perk.linkTarget === "_blank" ? "noopener noreferrer" : ""}
                        className="hover:text-blue-600 transition-colors"
                      >
                        {t(perk.nameKey)}
                      </Link>
                    </h3>
                    <p className="mt-3 text-sm text-gray-500">
                      {t(perk.descriptionKey)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}